import { nanoid } from "nanoid";
import { Box } from "@mui/material";
import { CreditConsentSection } from "./creditConsentSection";
import { PersonalDetailsSection } from "./personalDetailsSection";
import { MortgageCalculationsSection } from "./mortgageCalculationsSection";
import type { MortgagePayloadInterface } from "../../../interfaces/mortgageDetailsInterface";

interface MortgageDetailsSectionProps {
  mortgageDetails: MortgagePayloadInterface;
}

export const MortgageDetailsSection = ({
  mortgageDetails
}: MortgageDetailsSectionProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          flexWrap: "wrap",
          gap: 2
        }}
      >
        <PersonalDetailsSection mortgageDetails={mortgageDetails} />
        {(mortgageDetails.mortgage.maximumAffordability ||
          mortgageDetails.mortgage.zownContribution ||
          mortgageDetails.mortgage.creditScore ||
          mortgageDetails.mortgage.highestEligibleCreditScore ||
          mortgageDetails.mortgage.totalDownPaymentBuyerOnly ||
          mortgageDetails.mortgage.totalDownPaymentNeeded ||
          mortgageDetails.mortgage.totalNewDownPaymentNeeded ||
          mortgageDetails.mortgage.totalAnnualIncomeBuyerOnly ||
          mortgageDetails.mortgage.totalAnnualIncomeWithCoApplicants ||
          mortgageDetails.mortgage.totalMonthlyDebtBuyerOnly ||
          mortgageDetails.mortgage.totalDebtBuyerOnly ||
          mortgageDetails.mortgage.totalMonthlyDebtWithCoApplicants ||
          mortgageDetails.mortgage.totalDebtWithCoApplicants) && (
          <MortgageCalculationsSection mortgageDetails={mortgageDetails} />
        )}

        {/* <Paper elevation={4} sx={{ p: 2, mt: 2, flex: "1 1 calc(50% - 16px)" }}>
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography variant="subtitle1" color="primary">
              Suggestion:
            </Typography>
            <Typography variant="body1">
              {mortgageDetails.suggestions}
            </Typography>
          </Box>
        </Paper> */}
      </Box>
      {mortgageDetails.mortgage.creditConsents?.map((result) => (
        <CreditConsentSection key={nanoid()} result={result} />
      ))}
    </Box>
  );
};
